export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9766.66090aec.jpg";